module.exports = __webpack_public_path__ + "img/fillblanksentences.2670dde9.png";